import { LoginStorage, clearReturnUrl } from '@arredo/reactjs-ui';

import { clearGenericCustomerCache } from '../customers/useGenericCustomer';

/**
 * Sign the user out and restart the OAuth flow.
 *
 * The flow itself now lives in the toolkit's LoginProvider (see src/index.jsx);
 * what stays here is the POS-specific teardown that `LoginStorage.clear()`
 * cannot express on its own:
 *
 * - the generic-customer cache is keyed by branch, so its entries share a
 *   prefix rather than a fixed name and cannot be passed as `additionalKeys`.
 * - the parked deep link is dropped on purpose: unlike an expired session,
 *   this user asked to leave, so the next sign-in starts at the home page.
 *
 * `LoginStorage.clear()` navigates to the origin, so it has to go last.
 */
export const SignOut = () => {
    clearGenericCustomerCache();
    clearReturnUrl();
    LoginStorage.clear();
}
